import React, { useState, useRef } from 'react';
import { NavLink } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import styles from './ProfileIcon.module.scss';
import dropdownStyles from './DropdownMenu.module.scss';
import useOutsideClick from '../../hooks/useOutsideClick';
import useLogout from '../../hooks/useLogout';

const ProfileIcon = () => {
  const { accounts } = useMsal();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const userName = accounts[0]?.name || 'User';
  const userInitials = localStorage.getItem("profile_initial_credential") ? localStorage.getItem("profile_initial_credential") : userName.split(' ').map(n => n[0]).join('');

  useOutsideClick(dropdownRef, () => {
    if (dropdownOpen) {
      setDropdownOpen(false);
    }
  });

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  return (
    <div className={styles.profileContainer} ref={dropdownRef}>
      <button className={styles.profileIcon} onClick={toggleDropdown} aria-haspopup="true" aria-expanded={dropdownOpen}>
        <span>{userInitials}</span>
      </button>
      {dropdownOpen && <DropdownMenu setDropdownOpen={setDropdownOpen} />}
    </div>
  );
};

const DropdownMenu = ({ setDropdownOpen }) => {
    const handleLogout = useLogout();

  return (
    <div className={dropdownStyles.dropdownMenu}>
      <div className={dropdownStyles.dropdownHeader}>
        <button className={styles.profileIcon} aria-haspopup="true">
          <span>{localStorage.getItem("profile_initial_credential")}</span>
        </button>
        <span className={dropdownStyles.userName}><span className={dropdownStyles.userEmail}>Welcome </span><br/>{localStorage.getItem("profile_name")}</span>
      </div>
      <ul>
        <li>
          <NavLink to="/profile/api-secret-details" className={({ isActive }) => (isActive ? dropdownStyles.active : '')} onClick={() => setDropdownOpen(false)}>
            <i className="material-icons">person</i>
            <span>My Profile</span>
          </NavLink>
        </li>
        <li>
          <NavLink to="/settings" className={({ isActive }) => (isActive ? dropdownStyles.active : '')} onClick={() => setDropdownOpen(false)}>
            <i className="material-icons">settings</i>
            <span>Settings</span>
          </NavLink>
        </li>
        <li>
          <NavLink to="/support-ticket" className={({ isActive }) => (isActive ? dropdownStyles.active : '')} onClick={() => setDropdownOpen(false)}>
            <i className="material-icons">support_agent</i>
            <span>Support Ticket</span>
          </NavLink>
        </li>
        <li>
          <button onClick={handleLogout}>
            <i className="material-icons">logout</i>
            <span>Logout</span>
          </button>
        </li>
      </ul>
    </div>
  );
};

export default ProfileIcon;